import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import SU3defaultsoutputdevice from './../workinstructions/images/SU3defaultsoutputdevice.png';
import SU3parameters from './../workinstructions/images/SU3parameters.png';

class PrinterConfiguration extends React.Component {
	async componentDidMount() {
    document.title = "Nokia MN SAP Printer Configuration";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>Nokia MN Printer Configuration</PanelHeader>
					<PanelBody>
					<h2>Printer configuration</h2>
						<p>
							start SU3 =&gt; go to Tab-nav "Defaults" =&gt; go to inputfield Output-device and fill in the printername of the paper-printer at your workstation, CA05 etc. <br />
						<p> <img src={SU3defaultsoutputdevice} alt="SU3 tab defaults-printername" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
						<p> <img src={SU3parameters} alt="SU3 tab parameters" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; Nov 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default PrinterConfiguration;
